import { BasePageItemsClient, HomeDataSection, ProductShelvesSection } from "@core/types";

class PageItemsClient extends BasePageItemsClient {
  async getHome(): Promise<HomeDataSection[] | null> {
    throw new Error("getHome not implemented in core client");
  }

  async getPageItemById(id: string): Promise<ProductShelvesSection | null> {
   throw new Error("getPageItemById not implemented in core client");
  }
}

export default PageItemsClient;
